import React, {useEffect, useState} from 'react';
import {Avatar, Card} from "antd";
import {UserOutlined} from "@ant-design/icons";
import {useQueryClient} from "@tanstack/react-query";

const UserProfile = () => {
    const { Meta } = Card;
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const queryClient = useQueryClient();
    const userInfo = queryClient.getQueryData(['userInfo']);


    useEffect(() => {
        if (userInfo !== undefined) {
            setTitle(userInfo.data.name);
            setDescription(userInfo.data.role);
        }
    }, [userInfo]);


    return (
        <>
            <Card
                styles={{actions: {backgroundColor: 'rgb(220, 220, 220)', borderTop: '1px solid #c2c2c2'}}}
                style={{borderRadius: 0, backgroundColor: 'rgb(220, 220, 220)', boxShadow: 'none', borderBottom: '1px solid #c2c2c2'}}
                bordered={false}
            >
                <Meta avatar={<Avatar size='small' icon={<UserOutlined/>} />} title={title} description={description}/>
            </Card>
        </>
    );
};

export default UserProfile;